import MessageAttachmentCard from "./MessageAttachmentCard";
export default MessageAttachmentCard;
